import type { GetCookieValueFn } from './types';

import { getCookieValue as getCookieValueClient } from './client';
import { getCookieValue as getCookieValueServer } from './server';

export { COOKIES } from './constants';

export { setCookie, removeCookie } from './client';

export const getCookieValue: GetCookieValueFn = async (cookieName, shouldDecode = false) => {
    if (typeof document === 'undefined') {
        return getCookieValueServer(cookieName, shouldDecode);
    }

    return getCookieValueClient(cookieName, shouldDecode);
};
